import React from "react";

// 立方体の問題で、部品名・説明文の「上面」「手前」「奥」が何を基準にした向きかを示す注記（2026-10-19）。
// ヒントで視点を変えたあとの画面で読むと、画面の上なのか自分に向いた面なのか迷うため、
// 言葉はそのままにして「描き手（いつもの視点）から見た向き」という基準を1行で示す。
// 皿・グラスの部品名（飲み口・皿のふち等）は向きに頼らないので出さない。
export default function DirectionNote({ glbPath }) {
  if (!glbPath || !glbPath.startsWith("cube")) return null;
  return (
    <p className="direction-note">
      ※「上面」「手前」「奥」などの向きは、デッサンを描いた人から見た向きです。
    </p>
  );
}
